/**
 * Maps Appropriate Data for Pill Component in Segments List Based off Status
 * @param {string} statusText - ACTIVE, SAVED, etc.
 * @return {Object}
 * @property {string} color
 * @property {boolean} disabled
 * @property {string} tooltip
 */
const getStatusData = statusText => {
  const status = statusText
    ? statusText.toUpperCase()
    : '';

  switch (status) {
    case 'ACTIVE':
      return {
        color: 'WHITE_GREEN',
        disabled: false,
        tooltip: 'This segment is actively refreshing with the latest data'
      };
    case 'INACTIVE':
      return {
        color: 'SILVER',
        disabled: true,
        tooltip: 'This segment is not actively refreshing and is available for editing or activation',
      };
    case 'PROCESSING':
      return {
        color: 'SILVER',
        disabled: false,
        tooltip: 'This segment has been activated and is no longer available for editing',
      };
    case 'SAVED':
      return {
        color: 'SILVER',
        disabled: true,
        tooltip: 'This segment has not been activated and is available for editing',
      };
    default:
      return {
        color: 'SILVER',
        disabled: true,
      };
  }
};

export default getStatusData;
